export const isPhoneNumber = (string) => {
  return RegExp(/^^[0-9]*$/).test(string);
};
